import { Fence } from 'logic/reports/ReportSettings';
import { Size } from 'types';

export const overwriteFences = (xml: string, imageSize: Size, fences: Fence[]): string => {
    let match = /<Mask Name="CountFence"><Location>(.*?)<\/Location><\/Mask>/.exec(xml);
    if (!match) return xml;
    const originalMaskInnerXml = match[1];
    let maskInnerXml = match[1];

    let scaleX = (x: number) => x;
    let scaleY = (y: number) => y;
    match = /<Resolution width="(\d+)" height="(\d+)"/i.exec(maskInnerXml);
    if (match) {
        const width = parseInt(match[1], 10);
        const height = parseInt(match[2], 10);
        scaleX = x => Math.round(x * width / imageSize.width);
        scaleY = y => Math.round(y * height / imageSize.height);
    }

    // Remove all fences
    maskInnerXml = maskInnerXml.replace(/<Fence.*\/Fence>/gm, '');

    const fencesXml =
        fences.reduce(
            (f, { x1, y1, x2, y2 }) =>
                `${f}<Fence Alarm="Both"><Line X1="${scaleX(x1)}" Y1="${scaleY(y1)}" X2="${scaleX(x2)}" Y2="${scaleY(y2)}"/></Fence>`,
            ''
        );

    maskInnerXml = maskInnerXml + fencesXml;
    return xml.replace(originalMaskInnerXml, maskInnerXml);
};



// WEBPACK FOOTER //
// ./src/logic/addOnConfig/overwriteFences.ts